import { initAuthAction } from 'modules/auth/store/actions';
import { appService, authService } from 'modules';
import { AppConstants } from './constants';
import { Dispatch } from 'react';
import { getAccount } from 'modules/layout/store/actions';

export const hideNotification = (notificationKey: string) => (dispatch: Dispatch<{}>) => {
  appService.hideNotification(notificationKey);
  dispatch({ type: AppConstants.APP_HIDE_NOTIFICATION });
};

export const initAppAction = () => async (dispatch: Dispatch<{}>) => {
  const refreshToken = authService.getRefreshToken();

  if (refreshToken) {
    await dispatch(initAuthAction(refreshToken));
    await dispatch(getAccount());
  }

  dispatch({ type: AppConstants.APP_INITED });
};
